module.exports = __webpack_public_path__ + "static/media/chiennghe-info-cv.623bebf2.pdf";